import { useEffect, useState } from "react";
import { MenuService } from "../../../services/Menu.Service";
import { MenuItemDto } from "./MenuItem.Dto";
import MessageBoxModule from "../../../hook/MessageBox.Module";
import { useNavigate } from "react-router-dom";
import { AutenticacaoModule } from "src/Contexto/auth";

export const NavbarTopCode = () => {
  const [loading, setLoading] = useState(false);
  const [menuItems, setMenuItems] = useState<MenuItemDto[]>([]);
  const { ShowMessage } = MessageBoxModule();
  const navigate = useNavigate();
  const { logOut } = AutenticacaoModule();
  const CACHE_KEY = "menuItems";
  const CACHE_EXPIRATION_TIME = 30 * 60 * 1000;

  useEffect(() => {
    const Load = async () => {
      setLoading(true);

      const cachedData = localStorage.getItem(CACHE_KEY);

      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        const currentTime = new Date().getTime();

        if (currentTime - parsedData.timestamp < CACHE_EXPIRATION_TIME) {
          setMenuItems(parsedData.data);
          setLoading(false);
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }

      await MenuService()
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            const cacheObject = {
              data,
              timestamp: new Date().getTime(),
            };

            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheObject));
            setMenuItems(data);
          } else {
            console.error(response);
          }
        })
        .catch((error) => {
          setMenuItems([]);
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    Load();
  }, []);

  const SairMessage = () => {
    ShowMessage(
      "Deseja realmente sair da aplicação?",
      "Atenção!",
      "YesNo",
      "Info",
      {
        onYes: Sair,
      }
    );
  };

  const Sair = () => {
    logOut();
    navigate("/login");
  };

  return { menuItems, SairMessage, loading };
};
